module.exports = __webpack_public_path__ + "media/images/servico-textil-9d420665b6ca527a092b6c5a646dd24c.jpg";